import { useTranslation } from 'react-i18next'

import { Card, CardTitle, Skeleton } from '@reveni-io/reveni-ui'

import * as Styles from './styles'

const ShippingDetailsCardSkeleton = () => {
  const { t } = useTranslation()

  return (
    <Card showBorder={false}>
      <CardTitle>
        {t('Envío devolución')}
        <Skeleton variant="circular" width={24} height={24} />
      </CardTitle>
      <Styles.MainContainer>
        <Styles.Info>
          <Skeleton variant="text" width={100} height={14} />
          <Skeleton variant="rounded" width={80} height={20} />
        </Styles.Info>
        <Styles.Info>
          <Skeleton variant="text" width={120} height={14} />
          <Skeleton variant="rounded" width={140} height={20} />
        </Styles.Info>
        <Styles.Info>
          <Skeleton variant="text" width={60} height={14} />
          <Skeleton variant="rounded" width={120} height={20} />
        </Styles.Info>
        <Styles.Info>
          <Skeleton variant="text" width={100} height={14} />
          <Skeleton variant="rounded" width={90} height={20} />
          <Skeleton variant="rounded" width={70} height={20} />
          <Skeleton variant="rounded" width={30} height={20} />
          <Skeleton variant="rounded" width={150} height={20} />
          <Skeleton variant="rounded" width={50} height={20} />
        </Styles.Info>
      </Styles.MainContainer>
    </Card>
  )
}

export default ShippingDetailsCardSkeleton
